import { useAppSelector } from '@/app/store/hooks';
import { selectContacts } from '@/entities/home_content/model/selectors';
import { Footer } from '@/widgets/footer/ui/Footer';
import MobileSidebar from '@/widgets/menu/ui/MobileSidebar';
import Navbar from '@/widgets/menu/ui/Navbar';
import * as React from 'react';

import { ModalFeedback } from '@/shared/ui/Modal/ui/ModalFeedback';
import { cn } from '@/shared/lib/utils';
import { useCookieConsent } from '@/features/cookieConsent/model/useCookieConsent';

interface IMainLayoutProps {
  children: React.ReactNode;
  className?: string;
  wrClassName?: string;
}

export function MainLayout({
  children,
  className,
  wrClassName,
}: IMainLayoutProps) {
  const contacts = useAppSelector(selectContacts);

  const [isModal, setIsModal] = React.useState<boolean>(false);

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const { visible, setVisible } = useCookieConsent();

  const handleAccept = () => {
    setVisible(false);
  };

  return (
    <main
      className={cn(
        'h-full w-full overflow-y-auto overflow-x-hidden',
        wrClassName
      )}
    >
      <Navbar
        contacts={contacts}
        visible={visible}
        handleAccept={handleAccept}
      />
      <div
        className={cn(
          'flex flex-col items-center',
          className,
          visible ? 'pt-[118px] md:pt-[128px]' : 'pt-[60px] md:pt-[70px]'
        )}
      >
        {children}
      </div>

      <Footer contacts={contacts} />

      <ModalFeedback />

      <MobileSidebar contacts={contacts} />
    </main>
  );
}
